import React from 'react'
import { get, map } from 'lodash'

import Feature from './Feature'
import FeatureAccordion from './FeatureAccordion'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import { isTwoColsFeature } from '../../configuration/features'
import { getLeonardoFeatures } from '../../utilities/content/accommodationFeatures'

import '../../styles/scss/elements/features.scss'

const Features = ({ accommodation }) => {
  const { width } = useWindowDimensions()
  const SCREEN_SIZE_XLR = 1480
  const SCREEN_SIZE_LG = 1024
  const SCREEN_SIZE_MD = 768
  const SCREEN_SIZE_SMR = 500 // between SM and MD

  const amenitiesFallback = get(accommodation, 'amenities') || []
  const accommodationFeatureData = get(accommodation, 'viewExtensions.northstar')
  const features = getLeonardoFeatures(accommodationFeatureData, amenitiesFallback)

  return (
    <div className="features">
      {map(features, (feature, index) =>
        width > SCREEN_SIZE_MD ? (
          <Feature
            key={index}
            feature={feature}
            twoCols={
              isTwoColsFeature(feature?.type) &&
              (width > SCREEN_SIZE_XLR ||
                (width > SCREEN_SIZE_MD && width < SCREEN_SIZE_LG))
            }
          />
        ) : (
          <FeatureAccordion
            key={index}
            feature={feature}
            twoCols={isTwoColsFeature(feature?.type) && width > SCREEN_SIZE_SMR}
          />
        )
      )}
    </div>
  )
}

export default Features
